import ReactPlayer from "react-player/lazy";
export const VideoPlayer = ({ video_url, height = "260px" }) => {
  return <ReactPlayer url={video_url} controls width="100%" height={height} />;
};
